import React, { useEffect, useRef, useState } from "react";
import {
    format,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    subDays,
    subWeeks,
    subMonths,
} from "date-fns";

import { DateRange } from "react-date-range";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateFormatter = ({
    setDateForApi,
    clearDate,
    label = "Date Range",
    placeholder = "Select Date Range",
    fromKey = "from",
    toKey = "to",
}) => {

    const dropdownRef = useRef(null);

    const [showDropdown, setShowDropdown] = useState(false);

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
    });

    const [hasSelected, setHasSelected] = useState(false);

    useEffect(() => {

        if (hasSelected) {

            setDateForApi({
                [fromKey]: format(selectionRange.startDate, "yyyy-MM-dd"),
                [toKey]: format(selectionRange.endDate, "yyyy-MM-dd"),
            });

        } else {

            setDateForApi({
                [fromKey]: "",
                [toKey]: "",
            });

        }

    }, [selectionRange, hasSelected]);

    useEffect(() => {
        handleClear();
    }, [clearDate]);

    useEffect(() => {

        const handleClickOutside = (event) => {

            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }

        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);

    const handleClear = () => {

        setHasSelected(false);

        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        });

        setDateForApi({
            [fromKey]: "",
            [toKey]: "",
        });

    };

    const setRange = (start, end) => {

        setSelectionRange({
            startDate: start,
            endDate: end,
            key: "selection",
        });

        setHasSelected(true);

        setShowDropdown(false);

    };

    const today = new Date();

    const quickRanges = [
        {
            label: "Today",
            onClick: () => setRange(today, today),
        },
        {
            label: "Yesterday",
            onClick: () => setRange(subDays(today, 1), subDays(today, 1)),
        },
        {
            label: "Last 7 Days",
            onClick: () => setRange(subDays(today, 6), today),
        },
        {
            label: "This Week",
            onClick: () => setRange(startOfWeek(today), endOfWeek(today)),
        },
        {
            label: "Last Week",
            onClick: () =>
                setRange(
                    startOfWeek(subWeeks(today, 1)),
                    endOfWeek(subWeeks(today, 1))
                ),
        },
        {
            label: "This Month",
            onClick: () =>
                setRange(
                    startOfMonth(today),
                    endOfMonth(today)
                ),
        },
        {
            label: "Last Month",
            onClick: () =>
                setRange(
                    startOfMonth(subMonths(today, 1)),
                    endOfMonth(subMonths(today, 1))
                ),
        },
    ];

    return (
        <div className="position-relative" ref={dropdownRef}>

            <label className="form-label fw-semibold small">
                {label}
            </label>

            <div className="position-relative">

                <input
                    type="text"
                    readOnly
                    placeholder={placeholder}
                    className="form-control shadow-none"
                    value={
                        hasSelected
                            ? `${format(selectionRange.startDate, "MMM dd, yyyy")} - ${format(selectionRange.endDate, "MMM dd, yyyy")}`
                            : ""
                    }
                    onClick={() => setShowDropdown(!showDropdown)}
                    style={{
                        height: "40px",
                        cursor: "pointer",
                        fontSize: "15px",
                        paddingLeft: "48px",
                        paddingRight: "44px",
                        background: "#fff",
                        border: "1px solid #dfe3ea",
                    }}
                />

                <i
                    className="fa fa-calendar position-absolute top-50 start-0 translate-middle-y ms-3 text-primary"
                    style={{ fontSize: "17px" }}
                />

                {hasSelected && (
                    <button
                        type="button"
                        onClick={handleClear}
                        className="btn border-0 p-0 position-absolute top-50 end-0 translate-middle-y me-3"
                    >
                        <i className="fa fa-trash text-danger"></i>
                    </button>
                )}

            </div>

            {showDropdown && (
                <div
                    className="position-absolute bg-white shadow-lg"
                    style={{
                        width: "450px",
                        zIndex: 9999,
                        marginTop: "10px",
                        borderRadius: "16px",
                        overflow: "hidden",
                        border: "1px solid #e9ecef",
                    }}
                >

                    <div className="d-flex">

                        <div style={{ width: "120px" }}>
                            <div className="d-grid">
                                {quickRanges.map((item, index) => (
                                    <button
                                        key={index}
                                        onClick={item.onClick}
                                        className="btn text-start border-0 shadow-none rounded-0"
                                        style={{
                                            color: "#111827",
                                            borderBottom: "1px solid #e9ecef",
                                            padding: "10px 12px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: "flex" }}>
                            <DateRange
                                editableDateInputs={false}
                                onChange={(item) => {
                                    setSelectionRange(item.selection);
                                    setHasSelected(true);
                                }}
                                moveRangeOnFirstSelection={false}
                                ranges={[selectionRange]}
                                months={1}
                                direction="horizontal"
                                showDateDisplay={false}
                                rangeColors={["#2563eb"]}
                            />
                        </div>

                    </div>

                </div>
            )}

        </div>
    );
};

export default DateFormatter;